export const SET_STORE_CART_DETAILS_DATA = "SET_STORE_CART_DETAILS_DATA";
export const SET_PRODUCT_LIST = "SET_PRODUCT_LIST";
export const SET_WISH_LIST = "SET_WISH_LIST";
export const SET_LOGIN_TYPE = "SET_LOGIN_TYPE";